import { useState } from 'react'

export function useLocalStorage<T>({ key, defaultValue }: { key: string; defaultValue: T }): [T, (value: T) => void] {
    const [value, setValue] = useState<T>(
        localStorage.getItem(key) ? JSON.parse(localStorage.getItem(key)!) : defaultValue
    )

    return [
        value,
        (value: T) => {
            localStorage.setItem(key, JSON.stringify(value))
            setValue(value)
        },
    ]
}
